import { render, staticRenderFns } from "./AdminStudyGroupList.vue?vue&type=template&id=c9260836&"
import script from "./AdminStudyGroupList.vue?vue&type=script&lang=js&"
export * from "./AdminStudyGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports